import { Component, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-tos-viewer-dialog',
    templateUrl: './tos-viewer-dialog.component.html',
    styleUrls: ['./tos-viewer-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TosViewerDialogComponent {
  constructor(
    @Optional() private dialogRef?: MatDialogRef<TosViewerDialogComponent>
  ) {}

  close(): void {
    this.dialogRef?.close();
  }
}
